import type { EncodingProfile } from "../api/EncoderAPI.types";

export const VIDEO_FORMAT_KEYS: Record<string, keyof EncodingProfile> = {
  "2160p": "ott_video_2160p",
  "1080p": "ott_video_1080p",
  "720p": "ott_video_720p",
  "480p": "ott_video_480p",
  "360p": "ott_video_360p",
};

export const AUDIO_FORMAT_KEYS: Record<string, keyof EncodingProfile> = {
  "320kbps": "ott_audio_320k",
  "192kbps": "ott_audio_192k",
  "128kbps": "ott_audio_128k",
};

export const BITRATE_MARGIN = 30;

export const VIDEO_FORMAT = {
  "2160p": "2160p",
  "1080p": "1080p",
  "720p": "720p",
  "480p": "480p",
  "360p": "360p",
} as const;

export const VIDEO_FORMAT_LIST = Object.values(VIDEO_FORMAT);

export type VideoFormatKeys = keyof typeof VIDEO_FORMAT;

export type VideoFormat = (typeof VIDEO_FORMAT)[VideoFormatKeys];

export const AUDIO_FORMAT = {
  "320k": "320kbps",
  "192k": "192kbps",
  "128k": "128kbps",
} as const;

export const AUDIO_FORMAT_LIST = Object.values(AUDIO_FORMAT);

export type AudioFormatKeys = keyof typeof AUDIO_FORMAT;

export type AudioFormat = (typeof AUDIO_FORMAT)[AudioFormatKeys];
